import React, {useContext, useEffect} from "react";
import styled from "styled-components";
import { toast } from "react-toastify";


//
import Learn from "./sections/Learn";
import LearnColumns from "./sections/LearnColumns";
import AuthContext from "../../../../context/auth/AuthContext";
import {useParams} from "react-router-dom";
import CourseContext from "../../../../context/course/CourseContext";

export default function Course({ fn: {getOneCourse}}) {
  // context
  const {
    state: { isAuth },
  } = useContext(AuthContext);

  const {
    state: { course },
  } = useContext(CourseContext);

  const { id } = useParams();

  // methods
  function checkAuth() {
    if (!isAuth) return;
    toast.info("Go lesson !");
  }

  useEffect(() => {
    getOneCourse({ id });
  }, [ ])

  return (
    <StyledHtml>
      <Learn checkAuth={checkAuth} course={course}/>
      <LearnColumns checkAuth={checkAuth} course={course}/>
    </StyledHtml>
  );
}

const StyledHtml = styled.main``;
